import { render } from "./EsopTransactionsTable.vue?vue&type=template&id=6215a78e&scoped=true"
import script from "./EsopTransactionsTable.vue?vue&type=script&lang=js"
export * from "./EsopTransactionsTable.vue?vue&type=script&lang=js"

import "./EsopTransactionsTable.vue?vue&type=style&index=0&id=6215a78e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6215a78e"]])

export default __exports__